const RecentlyModel = require("@/appModel/Recently/RecentlyModel");
const TreeItemModel = require("@/appModel/Tree/TreeItemModel");
const DateUtil = require('@/appUtils/DateUtil')

class RecentlyViewModel {
  constructor(projectId, userSub, tenantId) {
    this.tenantId = tenantId
    this.list = []
    this.recentryList = []
    this.projectId = projectId
    this.userSub = userSub
  }
  async init() {
    let _list = await RecentlyModel.list(this.projectId, this.userSub, this.tenantId)
    // 登録日順でソート
    this.recentryList = _list.sort(function(a, b){
      if (a.lsiInt1 < b.lsiInt1) return 1;
      if (a.lsiInt1 > b.lsiInt1) return -1;
      return 0;
    }.bind(this))
    
    // 古いデータを削除
    const tmpList = [].concat(this.recentryList)
    await this.deleteOldData(tmpList)

    this.recentryList = this.recentryList.slice(0, 10)

    const sk = TreeItemModel.createSk(this.projectId)
    const treeItems = await TreeItemModel.list(sk, this.tenantId)
    let tmp = {}
    treeItems.forEach(function(item){
      tmp[item.sk] = item
    })
    this.list = []
    this.recentryList.forEach(function(item){
      if (tmp[item.recently.targetSk]){
        const arrayNum = this.list.push(tmp[item.recently.targetSk])
        
        this.list[arrayNum - 1].treePlace = item.recently.treePlace
        this.list[arrayNum - 1].refDate = item.recently.createdAt
        
      }
    }.bind(this))

  }
  async deleteOldData(list) {
    // 10件未満の場合は削除しない
    if (list.length <= 10) {
      return
    }
    
    let oldList = list.slice(10 - list.length)
    for (let i = 0; i < oldList.length;i++) {
      await RecentlyModel.delete(oldList[i])
    }

  }
  /**
   * 最近使用したファイルとして追加
   * @param {*} targetSk 
   * @param {*} treePlace 
   * @returns 
   */
  async addRecentlyfile(targetSk, treePlace) {
    let _list = await RecentlyModel.list(this.projectId, this.userSub, this.tenantId)
    
    // 直近登録済みチェック
    let existflg = false
    let existItems = []
    if (_list.length > 0) {
      //登録済みであれば更新とする
      existItems = _list.filter(function(item) {
        return item.recently.targetSk == targetSk
      })
      existflg = existItems.length > 0
      
    }
    
    if (existflg) {
      // 更新
      existItems[0].lsiInt1 = DateUtil.getUnixTimeStampOfSecond()
      await RecentlyModel.update(existItems[0])
    } else {
      // 新規
      let newData = await RecentlyModel.getNewData(this.projectId, this.userSub)
      newData.recently.targetSk = targetSk
      newData.recently.treePlace = treePlace
      await RecentlyModel.add(newData)
    }
    
  }
}
module.exports = RecentlyViewModel;